import React from "react";
import { Stack, Text, useViewport } from "@bookingcom/bui-react";
import { mcn } from "utils/mergeClassnames";
import styles from "./DealsBanner.module.css";

type Props = {
  title: string;
  subtitle: string;
  imageUrl: string;
  showSecondBanner?: boolean;
};

const DealsBanner = ({ title, subtitle, imageUrl, showSecondBanner = false }: Props) => {
  const { isLarge, isSmall } = useViewport();

  return (
    <div
      style={{
        background: `linear-gradient(0deg, rgba(0, 0, 0, 0.50) 0%, rgba(0, 0, 0, 0.50) 100%), url(${imageUrl}) ${
          !showSecondBanner && isLarge ? "center -60px" : "top"
        }/cover no-repeat`
      }}
      className={mcn(styles.container, !showSecondBanner && styles.centerContainer)}
    >
      <Stack direction="column">
        <Text variant="headline_3" color="white">
          {title}
        </Text>
        <Text
          variant="body_2"
          color="white"
          attributes={{
            style: {
              maxWidth: showSecondBanner || isSmall ? 220 : ""
            }
          }}
        >
          {subtitle}
        </Text>
      </Stack>
    </div>
  );
};

export default DealsBanner;
